module.exports = __webpack_public_path__ + "db4d1f2327f73efdfdc089bbca2e65b5.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/font/OpenSans-CondBold.ttf
 ** module id = 905
 ** module chunks = 9
 **/